import { useEffect } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import i18n from '../i18n/index.js'
import { useMeQuery } from '../api/auth.js'
import { LoadingScreen } from '../components/LoadingScreen.js'

/**
 * Exige sesión para todo lo que envuelve. Complementa el manejo centralizado
 * del 401 de `query-client.ts` (que redirige a `/login` en cualquier
 * petición): esto evita además que se llegue a pintar contenido protegido
 * mientras esa redirección todavía no ha surtido efecto.
 */
export function ProtectedRoute() {
  const me = useMeQuery()

  useEffect(() => {
    if (me.data) void i18n.changeLanguage(me.data.locale)
  }, [me.data])

  if (me.isPending) return <LoadingScreen />
  if (me.isError) return <Navigate to="/login" replace />

  return <Outlet />
}
